import { http } from './client';

export interface DepositFollowup {
  pending: boolean;
  urgent: boolean;
  daysUntilStart: number | null;
  reasons: string[];
  configurations: Array<{
    configurationId: string | null; name: string; estimateId: string | null; estimateNumber: string | null;
    depositId: string | null; depositNumber: string | null; acceptedAt: string | null;
    status: string; label: string; pending: boolean; sentAt: string | null;
  }>;
}
export interface DepositFollowupShow {
  eventId: string;
  eventName: string;
  approved: boolean;
  depositFollowup: DepositFollowup;
  coordinatorCount?: number;
  coordinators?: Array<{ _id: string; fullName: string }>;
}
export async function loadDepositFollowups(): Promise<{ shows: DepositFollowupShow[]; truncated: boolean }> {
  const { response, error } = await http({ method: 'GET', url: 'dashboard/deposit-followup', isToken: true });
  if (error) throw error;
  const data = response?.data?.data ?? response?.data;
  return { shows: Array.isArray(data?.shows) ? data.shows : [], truncated: data?.truncated === true };
}
